import * as React from 'react'
import { type VariantProps } from 'class-variance-authority'

import { Button as UIButton, buttonVariants } from '@/components/ui/button'

interface ButtonProps
  extends
    React.ComponentPropsWithoutRef<typeof UIButton>,
    VariantProps<typeof buttonVariants> {
  prefixIcon?: React.ComponentType<{ className?: string }>
  suffixIcon?: React.ComponentType<{ className?: string }>
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { suffixIcon: SuffixIcon, prefixIcon: PrefixIcon, children, ...props },
    ref
  ) => {
    return (
      <UIButton ref={ref} {...props}>
        {PrefixIcon && <PrefixIcon />}
        {children}
        {SuffixIcon && <SuffixIcon />}
      </UIButton>
    )
  }
)

Button.displayName = 'ExtendedButton'

export default Button
